import AiAssitant from "@quark/ai-assistant";
import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import "@quark/ai-assistant/dist/index.css";
import styles from "./index.module.scss";
import cn from "classnames";
import useProfile from "../../hooks/use-profile";
import { HIDE_ASSISTANT_EVENT } from "../../constants";
import AiIcon from "./ai.png";
import { AptitudeTest } from "@quark/aptitude-test";
import "@quark/aptitude-test/dist/index.css";

interface AssistantWrapperProps {
  children: ReactNode;
}

const AssistantWrapper: FC<AssistantWrapperProps> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const profile = useProfile();
  const show = useMemo(() => {
    return true;
    // return [6, 20714, 36498].includes(profile?.user_id || 0);
  }, [profile]);

  // 仅在登录且未购买课程且未购买vip时显示
  const showAptitudeTestTrigger = useMemo(() => {
    return false;
    // const { is_login, has_course, vip_infos = [] } = profile || {};
    // return is_login && !has_course && !vip_infos.length;
  }, [profile]);
  const [aptitideTestVisible, setAptitudeTestVisible] = useState(false);

  const toggleVisible = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    const hide = () => {
      setVisible(false);
    };
    window.addEventListener(HIDE_ASSISTANT_EVENT, hide);

    return () => {
      window.removeEventListener(HIDE_ASSISTANT_EVENT, hide);
    };
  }, [visible]);

  return (
    <>
      {children}

      {show && (
        <div
          className={cn(styles.assistant, visible && styles.visible)}
          onClick={toggleVisible}
        >
          {visible ? (
            <div className={styles.close}></div>
          ) : (
            <img src={AiIcon} />
          )}
        </div>
      )}

      {showAptitudeTestTrigger && (
        <div
          className={cn(styles.aptitudeTest)}
          onClick={() => setAptitudeTestVisible(true)}
        >
          🔥 测试我的编程天赋
        </div>
      )}

      {aptitideTestVisible && (
        <div
          className={cn(styles.modal, aptitideTestVisible && styles.visible)}
        >
          <AptitudeTest
            onFinish={() => {}}
            onClose={() => setAptitudeTestVisible(false)}
          />
        </div>
      )}

      <div className={cn(styles.modal, visible && styles.visible)}>
        <AiAssitant
          onUpdate={() => setVisible(true)}
          onClose={() => setVisible(false)}
        />
      </div>
    </>
  );
};

export default AssistantWrapper;
